import { createFileRoute } from '@tanstack/react-router';
import SupportSection from '@/components/Support/SupportSection';
import { tw } from '@/lib/tailwind';

/**
 * PRIMARY ROUTE: Support Access / Account Settings
 *
 * Pure Alchemer functionality for managing account settings and support access.
 * This route does not use ThoughtSpot - it's entirely custom Alchemer UI.
 *
 * Features:
 * - Display account details (email, CID, name)
 * - Support access toggle and duration controls
 * - Help/FAQ information
 *
 * URL Pattern: /dashboard/support-access
 *
 * Architecture Note:
 * Located in `_primary-routes/` because it doesn't use ThoughtSpot's prerendered embed.
 * This is pure Alchemer functionality separate from analytics/BI features.
 */
export const Route = createFileRoute('/dashboard/_primary-routes/support-access')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="h-[calc(100vh-var(--dashboard-menu-height))] w-full">
      <div className={tw('m-5 mx-auto flex h-full w-full max-w-250 flex-col gap-9 rounded-lg bg-white p-5')}>
        <SupportSection />
      </div>
    </div>
  );
}
